import React, { Component } from 'react';
import _ from 'lodash';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Card from '../../../components/Card';
import Notification from '../../../components/Notification';


class ListCardItens extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMd: 'is-visible',
      hiddenMd: 'bx--modal bx--modal',
    };
  }

  static propTypes = {
    // openModal: PropTypes.func,
    hiddenModal: PropTypes.func,
  };

  static defaultProps = {
    // openModal: obj => null,
    hiddenModal: () => null,
  };

  render() {
    const { showMd, hiddenMd } = this.state;
    const { openMd, data, dates, className } = this.props;

    return (
      <div>
        <div className={openMd ? showMd : hiddenMd}>
          <div className="">       
            <div className="bx--row">
              {data.length > 0 && data.map(item => (
                <div className="bx--col-md-3" key={_.uniqueId()}>
                  <div className="item-list">
                    <label className="bx--label">
                      {item.nome}
                      <br />
                      <span>
                        {`Período:  ${dates.dateInit} à ${dates.dateFinish}`}
                      </span>
                    </label>
                                     
                    <Card className={`dashboard-card dashboard-card--trade ${className||""}`}>
                      {item.list.map(obj => {
                        const classNames = [
                          'dashboard-card-item',
                          obj.extra ? 'dashboard-card-item--extra' : '',
                          obj.featured ? 'dashboard-card-item--bold' : ''
                        ].join(' ');
                        return (
                          <NavLink to={obj.url || "#"} style={{cursor: obj.url ? 'pointer':'default'}} key={_.uniqueId()} className={classNames}>
                            <div className="description">{obj.label}</div>
                            <div className="count">{obj.total}</div>
                          </NavLink>
                        );
                      })}
                    </Card>
                  </div>
                </div>
              ))}
              {!data.length && (
                <div className="bx--col-md-12 bx--col-xs-12 bx--col-sm-12">
                  <Notification
                    kind="warning"
                    title="Não há dados"
                    description="Nenhum dado foi encontrado para o período informado."
                  />
                </div>
              )}

            </div>

          </div>
        </div>
      </div>
    );
  }
}
export default ListCardItens;



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/ListCardItens.js